import { writable } from "svelte/store";
import type { UserDataInput } from "../../lib/api/user";

export type UserStore = {
  user: UserDataInput,
  hasLoaded: boolean,
  customFields: Record<string, boolean | string>,
  ranInitialValidation: boolean,
  entryGateData: Record<string, string>
}

export const updateUserStore = (partialUser: Partial<UserStore>) => {
  userStore.update((data) => ({ ...data, ...partialUser }));
};

export const setRanInitialValidation = (ranInitialValidation: boolean) => {
  updateUserStore({ ranInitialValidation });
};

export const setCustomFields = (customFields: Record<string, boolean | string>) => {
  updateUserStore({ customFields });
};

export const setUser = (user: UserDataInput) => {
  updateUserStore({ user, hasLoaded: true });
};

export const setLoaded = (hasLoaded: boolean) => {
  updateUserStore({ hasLoaded });
};

export function initStore() {
  const store = writable<UserStore>();
  store.set({
    user: {
      first_name: "",
      last_name: "",
      email: "",
      phone: ""
    },
    hasLoaded: false,
    customFields: {},
    ranInitialValidation: false,
    entryGateData: {}
  });
  return store;
}

export const userStore = initStore();
